import React, { useEffect, useState } from 'react';

import WoocommerceAPI from '../../../IPSAPI/WoocommerceAPI'; 




function BlockHeaderV2({ settings, quantity, toggleSidebar, total, convertToEuro}) {
 // const [cartcount, setCartCount] = useState(0);

  useEffect(() => {
   // console.log('cartItems prop has changed:', quantity);
  }, [quantity]);









 

    return (
      <>
      
      <div class="row p-2 py-3 mx-0 ips-sidecart-elementheader ">

      <div class="ips-sidecart-header-view2">
        
        {/* -------------------------------------------------------------------------------------------------------*/}

        <div class="col-12 p-0">
        <div class="row p-0">
        <div class="col-8 p-0 d-flex align-items-center justify-content-start ips-headerv2-title">Warenkorb</div>
        <div class="col-4 p-0 d-flex align-items-center justify-content-start ips-action-btn ips-style-text ips-cross-icon">Schließen</div>


        </div>
       
          </div>

      </div>
     
      </div>
    
    
     
        
      </>
    );
  
}

export default BlockHeaderV2;